import axios, {
  AxiosError,
  AxiosResponse,
  InternalAxiosRequestConfig,
} from "axios";

export const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
});

const requestHandler = (request: InternalAxiosRequestConfig) => {
  const token = localStorage.getItem("token");
  if (token) {
    request.headers.Authorization = `Bearer ${token}`;
    return request;
  } else {
    localStorage.clear();
    window.location.href = "/auth/signin";
    return Promise.reject("No token available");
  }
};

const responseHandler = (response: AxiosResponse) => {
  // if (response.data.code === 200 || response.data.code === 201) {
  return response;
  // } else {
  //   console.log(response);
  // }
};

const errorHandler = (error: any) => {
  if (error?.response?.status === 401) {
    const originalRequest = error.config;

    // back-button brownsing issue - if user logouts and comes back on same page it will redirect to sign page
    if (
      !localStorage.getItem("token") &&
      !localStorage.getItem("refresh_token")
    ) {
      window.location.href = "/auth/signin";
    }

    if (error?.response?.data?.message === "jwt expired") {
      return refreshToken()
        .then(() => {
          // Retry the original request with new access token
          const token = localStorage.getItem("token");
          originalRequest.headers.Authorization = `Bearer ${token}`;
          return axiosInstance(originalRequest);
        })
        .catch((refreshError) => {
          // If refreshing fails, log out the user
          localStorage.clear();
          window.location.href = "/auth/signin";
          return Promise.reject(refreshError);
        });
    } else if (
      error?.response?.data?.message === "Refresh token expired" ||
      error?.response?.data?.message === "Login somewhere else"
    ) {
      localStorage.clear();
      window.location.href = "/auth/signin";
    }
    // Check if the error is due to the refresh token expiring
    // if (error?.response?.data?.message === "Refresh token expired") {
    //   // Logout user if refresh token expired
    //   localStorage.clear();
    //   window.location.href = "/auth/signin";
    //   return Promise.reject(error);
    // } else {
    //   localStorage.clear();
    //   window.location.href = "/auth/signin";
    // }

    // // If it's not the refresh token expiring, try to refresh the tokens
    // return refreshToken()
    //   .then(() => {
    //     // Retry the original request with new access token
    //     const token = localStorage.getItem("token");
    //     originalRequest.headers.Authorization = `Bearer ${token}`;
    //     return axiosInstance(originalRequest);
    //   })
    //   .catch((refreshError) => {
    //     // If refreshing fails, log out the user
    //     localStorage.clear();
    //     window.location.href = "/auth/signin";
    //     return Promise.reject(refreshError);
    //   });
  }
  return Promise.reject(error);
};

axiosInstance.interceptors.request.use((request) => {
  const token = localStorage.getItem("token");
  if (token) {
    request.headers.Authorization = `Bearer ${token}`;
  }
  return request;
});

axiosInstance.interceptors.response.use(
  (response) => responseHandler(response),
  (error) => errorHandler(error)
);

async function refreshToken() {
  const refreshToken = localStorage.getItem("refresh_token");

  return await axios
    .get(`${process.env.REACT_APP_BACKEND_URL}/api/admin/user/refresh-token`, {
      headers: {
        Authorization: `Bearer ${refreshToken}`,
      },
    })
    .then((response) => {
      const token = response.data.newAccessToken;
      const refresh_token = response.data.newRefreshToken;
      if (token) {
        // Save the new tokens
        localStorage.setItem("token", token);
        localStorage.setItem("refresh_token", refresh_token);
      }
    })
    .catch((error) => {
      // If refresh token fails, clear storage and redirect to login
      localStorage.clear();
      window.location.href = "/auth/signin";
      return Promise.reject(error);
    });
}
